"use strict";

var _createForOfIteratorHelper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _objectSpread = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _regeneratorRuntime = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactNative = void 0;

var sdpTransform = __importStar(require("sdp-transform"));

var Logger_1 = require("../Logger");

var errors_1 = require("../errors");

var utils = __importStar(require("../utils"));

var ortc = __importStar(require("../ortc"));

var sdpCommonUtils = __importStar(require("./sdp/commonUtils"));

var sdpPlanBUtils = __importStar(require("./sdp/planBUtils"));

var HandlerInterface_1 = require("./HandlerInterface");

var RemoteSdp_1 = require("./sdp/RemoteSdp");

var logger = new Logger_1.Logger('ReactNative');
var SCTP_NUM_STREAMS = {
  OS: 1024,
  MIS: 1024
};

var ReactNative = /*#__PURE__*/function (_HandlerInterface_1$H) {
  _inherits(ReactNative, _HandlerInterface_1$H);

  var _super = _createSuper(ReactNative);

  _createClass(ReactNative, null, [{
    key: "createFactory",

    /**
     * Creates a factory function.
     */
    value: function createFactory() {
      return function () {
        return new ReactNative();
      };
    }
  }]);

  function ReactNative() {
    var _this;

    _classCallCheck(this, ReactNative);

    _this = _super.call(this); // Local stream for sending.

    _this._sendStream = new MediaStream(); // Map of sending MediaStreamTracks indexed by localId.

    _this._mapSendLocalIdTrack = new Map(); // Next sending localId.

    _this._nextSendLocalId = 0; // Map of MID, RTP parameters and RTCRtpReceiver indexed by local id.
    // Value is an Object with mid, rtpParameters and rtpReceiver.

    _this._mapRecvLocalIdInfo = new Map(); // Whether a DataChannel m=application section has been created.

    _this._hasDataChannelMediaSection = false; // Sending DataChannel id value counter. Incremented for each new DataChannel.

    _this._nextSendSctpStreamId = 0; // Got transport local and remote parameters.

    _this._transportReady = false;
    return _this;
  }

  _createClass(ReactNative, [{
    key: "close",
    value: function close() {
      logger.debug('close()'); // Free/dispose native MediaStream but DO NOT free/dispose native
      // MediaStreamTracks (that is parent's business).
      // @ts-ignore (proprietary API in react-native-webrtc).

      this._sendStream.release(
      /* releaseTracks */
      false); // Close RTCPeerConnection.


      if (this._pc) {
        try {
          this._pc.close();
        } catch (error) {}
      }

      this.emit('@close');
    }
  }, {
    key: "getNativeRtpCapabilities",
    value: function () {
      var _getNativeRtpCapabilities = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var pc, offer, sdpObject, nativeRtpCapabilities;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                logger.debug('getNativeRtpCapabilities()');
                pc = new RTCPeerConnection({
                  iceServers: [],
                  iceTransportPolicy: 'all',
                  bundlePolicy: 'max-bundle',
                  rtcpMuxPolicy: 'require',
                  sdpSemantics: 'plan-b'
                });
                _context.prev = 2;
                _context.next = 5;
                return pc.createOffer({
                  offerToReceiveAudio: true,
                  offerToReceiveVideo: true
                });

              case 5:
                offer = _context.sent;

                try {
                  pc.close();
                } catch (error) {}

                sdpObject = sdpTransform.parse(offer.sdp);
                nativeRtpCapabilities = sdpCommonUtils.extractRtpCapabilities({
                  sdpObject: sdpObject
                });
                return _context.abrupt("return", nativeRtpCapabilities);

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](2);

                try {
                  pc.close();
                } catch (error2) {}

                throw _context.t0;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 12]]);
      }));

      function getNativeRtpCapabilities() {
        return _getNativeRtpCapabilities.apply(this, arguments);
      }

      return getNativeRtpCapabilities;
    }()
  }, {
    key: "getNativeSctpCapabilities",
    value: function () {
      var _getNativeSctpCapabilities = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                logger.debug('getNativeSctpCapabilities()');
                return _context2.abrupt("return", {
                  numStreams: SCTP_NUM_STREAMS
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getNativeSctpCapabilities() {
        return _getNativeSctpCapabilities.apply(this, arguments);
      }

      return getNativeSctpCapabilities;
    }()
  }, {
    key: "run",
    value: function run(_ref) {
      var _this2 = this;

      var direction = _ref.direction,
          iceParameters = _ref.iceParameters,
          iceCandidates = _ref.iceCandidates,
          dtlsParameters = _ref.dtlsParameters,
          sctpParameters = _ref.sctpParameters,
          iceServers = _ref.iceServers,
          iceTransportPolicy = _ref.iceTransportPolicy,
          additionalSettings = _ref.additionalSettings,
          proprietaryConstraints = _ref.proprietaryConstraints,
          extendedRtpCapabilities = _ref.extendedRtpCapabilities;
      logger.debug('run()');
      this._direction = direction;
      this._remoteSdp = new RemoteSdp_1.RemoteSdp({
        iceParameters: iceParameters,
        iceCandidates: iceCandidates,
        dtlsParameters: dtlsParameters,
        sctpParameters: sctpParameters,
        planB: true
      });
      this._sendingRtpParametersByKind = {
        audio: ortc.getSendingRtpParameters('audio', extendedRtpCapabilities),
        video: ortc.getSendingRtpParameters('video', extendedRtpCapabilities)
      };
      this._sendingRemoteRtpParametersByKind = {
        audio: ortc.getSendingRemoteRtpParameters('audio', extendedRtpCapabilities),
        video: ortc.getSendingRemoteRtpParameters('video', extendedRtpCapabilities)
      };

      if (dtlsParameters.role && dtlsParameters.role !== 'auto') {
        this._forcedLocalDtlsRole = dtlsParameters.role === 'server' ? 'client' : 'server';
      }

      this._pc = new RTCPeerConnection(_objectSpread({
        iceServers: iceServers || [],
        iceTransportPolicy: iceTransportPolicy || 'all',
        bundlePolicy: 'max-bundle',
        rtcpMuxPolicy: 'require',
        sdpSemantics: 'plan-b'
      }, additionalSettings), proprietaryConstraints);

      if (this._pc.connectionState) {
        this._pc.addEventListener('connectionstatechange', function () {
          _this2.emit('@connectionstatechange', _this2._pc.connectionState);
        });
      } else {
        this._pc.addEventListener('iceconnectionstatechange', function () {
          logger.warn('run() | pc.connectionState not supported, using pc.iceConnectionState');

          switch (_this2._pc.iceConnectionState) {
            case 'checking':
              _this2.emit('@connectionstatechange', 'connecting');

              break;

            case 'connected':
            case 'completed':
              _this2.emit('@connectionstatechange', 'connected');

              break;

            case 'failed':
              _this2.emit('@connectionstatechange', 'failed');

              break;

            case 'disconnected':
              _this2.emit('@connectionstatechange', 'disconnected');

              break;

            case 'closed':
              _this2.emit('@connectionstatechange', 'closed');

              break;
          }
        });
      }
    }
  }, {
    key: "updateIceServers",
    value: function () {
      var _updateIceServers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(iceServers) {
        var configuration;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                logger.debug('updateIceServers()');
                configuration = this._pc.getConfiguration();
                configuration.iceServers = iceServers;

                this._pc.setConfiguration(configuration);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function updateIceServers(_x) {
        return _updateIceServers.apply(this, arguments);
      }

      return updateIceServers;
    }()
  }, {
    key: "restartIce",
    value: function () {
      var _restartIce = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(iceParameters) {
        var offer, answer, _offer, _answer;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                logger.debug('restartIce()'); // Provide the remote SDP handler with new remote ICE parameters.

                this._remoteSdp.updateIceParameters(iceParameters);

                if (this._transportReady) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return");

              case 4:
                if (!(this._direction === 'send')) {
                  _context4.next = 17;
                  break;
                }

                _context4.next = 7;
                return this._pc.createOffer({
                  iceRestart: true
                });

              case 7:
                offer = _context4.sent;
                logger.debug('restartIce() | calling pc.setLocalDescription() [offer:%o]', offer);
                _context4.next = 11;
                return this._pc.setLocalDescription(offer);

              case 11:
                answer = {
                  type: 'answer',
                  sdp: this._remoteSdp.getSdp()
                };
                logger.debug('restartIce() | calling pc.setRemoteDescription() [answer:%o]', answer);
                _context4.next = 15;
                return this._pc.setRemoteDescription(answer);

              case 15:
                _context4.next = 27;
                break;

              case 17:
                _offer = {
                  type: 'offer',
                  sdp: this._remoteSdp.getSdp()
                };
                logger.debug('restartIce() | calling pc.setRemoteDescription() [offer:%o]', _offer);
                _context4.next = 21;
                return this._pc.setRemoteDescription(_offer);

              case 21:
                _context4.next = 23;
                return this._pc.createAnswer();

              case 23:
                _answer = _context4.sent;
                logger.debug('restartIce() | calling pc.setLocalDescription() [answer:%o]', _answer);
                _context4.next = 27;
                return this._pc.setLocalDescription(_answer);

              case 27:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function restartIce(_x2) {
        return _restartIce.apply(this, arguments);
      }

      return restartIce;
    }()
  }, {
    key: "getTransportStats",
    value: function () {
      var _getTransportStats = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this._pc.getStats());

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getTransportStats() {
        return _getTransportStats.apply(this, arguments);
      }

      return getTransportStats;
    }()
  }, {
    key: "send",
    value: function () {
      var _send = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref2) {
        var track, encodings, codecOptions, codec, _a, offer, localSdpObject, offerMediaObject, sendingRtpParameters, sendingRemoteRtpParameters, idx, _iterator, _step, encoding, answer, localId;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                track = _ref2.track, encodings = _ref2.encodings, codecOptions = _ref2.codecOptions, codec = _ref2.codec;
                this.assertSendDirection();
                logger.debug('send() [kind:%s, track.id:%s]', track.kind, track.id);

                if (codec) {
                  logger.warn('send() | codec selection is not available in %s handler', this.name);
                }

                this._sendStream.addTrack(track);

                this._pc.addStream(this._sendStream);

                _context6.next = 8;
                return this._pc.createOffer();

              case 8:
                offer = _context6.sent;
                localSdpObject = sdpTransform.parse(offer.sdp);
                sendingRtpParameters = utils.clone(this._sendingRtpParametersByKind[track.kind], {});
                sendingRtpParameters.codecs = ortc.reduceCodecs(sendingRtpParameters.codecs);
                sendingRemoteRtpParameters = utils.clone(this._sendingRemoteRtpParametersByKind[track.kind], {});
                sendingRemoteRtpParameters.codecs = ortc.reduceCodecs(sendingRemoteRtpParameters.codecs);

                if (this._transportReady) {
                  _context6.next = 17;
                  break;
                }

                _context6.next = 17;
                return this.setupTransport({
                  localDtlsRole: (_a = this._forcedLocalDtlsRole) !== null && _a !== void 0 ? _a : 'client',
                  localSdpObject: localSdpObject
                });

              case 17:
                if (track.kind === 'video' && encodings && encodings.length > 1) {
                  logger.debug('send() | enabling simulcast');
                  localSdpObject = sdpTransform.parse(offer.sdp);
                  offerMediaObject = localSdpObject.media.find(function (m) {
                    return m.type === 'video';
                  });
                  sdpPlanBUtils.addLegacySimulcast({
                    offerMediaObject: offerMediaObject,
                    track: track,
                    numStreams: encodings.length
                  });
                  offer = {
                    type: 'offer',
                    sdp: sdpTransform.write(localSdpObject)
                  };
                }

                logger.debug('send() | calling pc.setLocalDescription() [offer:%o]', offer);
                _context6.next = 21;
                return this._pc.setLocalDescription(offer);

              case 21:
                localSdpObject = sdpTransform.parse(this._pc.localDescription.sdp);
                offerMediaObject = localSdpObject.media.find(function (m) {
                  return m.type === track.kind;
                }); // Set RTCP CNAME.

                sendingRtpParameters.rtcp.cname = sdpCommonUtils.getCname({
                  offerMediaObject: offerMediaObject
                }); // Set RTP encodings.

                sendingRtpParameters.encodings = sdpPlanBUtils.getRtpEncodings({
                  offerMediaObject: offerMediaObject,
                  track: track
                }); // Complete encodings with given values.

                if (encodings) {
                  for (idx = 0; idx < sendingRtpParameters.encodings.length; ++idx) {
                    if (encodings[idx]) {
                      Object.assign(sendingRtpParameters.encodings[idx], encodings[idx]);
                    }
                  }
                } // If VP8 or H264 and there is effective simulcast, add scalabilityMode to
                // each encoding.


                if (sendingRtpParameters.encodings.length > 1 && (sendingRtpParameters.codecs[0].mimeType.toLowerCase() === 'video/vp8' || sendingRtpParameters.codecs[0].mimeType.toLowerCase() === 'video/h264')) {
                  _iterator = _createForOfIteratorHelper(sendingRtpParameters.encodings);

                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      encoding = _step.value;
                      encoding.scalabilityMode = 'L1T3';
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                }

                this._remoteSdp.send({
                  offerMediaObject: offerMediaObject,
                  offerRtpParameters: sendingRtpParameters,
                  answerRtpParameters: sendingRemoteRtpParameters,
                  codecOptions: codecOptions
                });

                answer = {
                  type: 'answer',
                  sdp: this._remoteSdp.getSdp()
                };
                logger.debug('send() | calling pc.setRemoteDescription() [answer:%o]', answer);
                _context6.next = 32;
                return this._pc.setRemoteDescription(answer);

              case 32:
                localId = String(this._nextSendLocalId);
                this._nextSendLocalId++; // Insert into the map.

                this._mapSendLocalIdTrack.set(localId, track);

                return _context6.abrupt("return", {
                  localId: localId,
                  rtpParameters: sendingRtpParameters
                });

              case 36:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function send(_x3) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }, {
    key: "stopSending",
    value: function () {
      var _stopSending = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(localId) {
        var track, offer, answer;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.assertSendDirection();
                logger.debug('stopSending() [localId:%s]', localId);
                track = this._mapSendLocalIdTrack.get(localId);

                if (track) {
                  _context7.next = 5;
                  break;
                }

                throw new Error('track not found');

              case 5:
                this._mapSendLocalIdTrack.delete(localId);

                this._sendStream.removeTrack(track);

                this._pc.addStream(this._sendStream);

                _context7.next = 10;
                return this._pc.createOffer();

              case 10:
                offer = _context7.sent;
                logger.debug('stopSending() | calling pc.setLocalDescription() [offer:%o]', offer);
                _context7.prev = 12;
                _context7.next = 15;
                return this._pc.setLocalDescription(offer);

              case 15:
                _context7.next = 23;
                break;

              case 17:
                _context7.prev = 17;
                _context7.t0 = _context7["catch"](12);

                if (!(this._sendStream.getTracks().length === 0)) {
                  _context7.next = 22;
                  break;
                }

                logger.warn('stopSending() | ignoring expected error due no sending tracks: %s', _context7.t0.toString());
                return _context7.abrupt("return");

              case 22:
                throw _context7.t0;

              case 23:
                if (!(this._pc.signalingState === 'stable')) {
                  _context7.next = 25;
                  break;
                }

                return _context7.abrupt("return");

              case 25:
                answer = {
                  type: 'answer',
                  sdp: this._remoteSdp.getSdp()
                };
                logger.debug('stopSending() | calling pc.setRemoteDescription() [answer:%o]', answer);
                _context7.next = 29;
                return this._pc.setRemoteDescription(answer);

              case 29:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[12, 17]]);
      }));

      function stopSending(_x4) {
        return _stopSending.apply(this, arguments);
      }

      return stopSending;
    }() // eslint-disable-next-line @typescript-eslint/no-unused-vars

  }, {
    key: "pauseSending",
    value: function () {
      var _pauseSending = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(localId) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function pauseSending(_x5) {
        return _pauseSending.apply(this, arguments);
      }

      return pauseSending;
    }() // eslint-disable-next-line @typescript-eslint/no-unused-vars

  }, {
    key: "resumeSending",
    value: function () {
      var _resumeSending = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(localId) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function resumeSending(_x6) {
        return _resumeSending.apply(this, arguments);
      }

      return resumeSending;
    }()
  }, {
    key: "replaceTrack",
    value: function () {
      var _replaceTrack = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10( // eslint-disable-next-line @typescript-eslint/no-unused-vars
      localId, track) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                throw new errors_1.UnsupportedError('not implemented');

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function replaceTrack(_x7, _x8) {
        return _replaceTrack.apply(this, arguments);
      }

      return replaceTrack;
    }() // eslint-disable-next-line @typescript-eslint/no-unused-vars

  }, {
    key: "setMaxSpatialLayer",
    value: function () {
      var _setMaxSpatialLayer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(localId, spatialLayer) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                throw new errors_1.UnsupportedError('not implemented');

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function setMaxSpatialLayer(_x9, _x10) {
        return _setMaxSpatialLayer.apply(this, arguments);
      }

      return setMaxSpatialLayer;
    }() // eslint-disable-next-line @typescript-eslint/no-unused-vars

  }, {
    key: "setRtpEncodingParameters",
    value: function () {
      var _setRtpEncodingParameters = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(localId, params) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                throw new errors_1.UnsupportedError('not implemented');

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function setRtpEncodingParameters(_x11, _x12) {
        return _setRtpEncodingParameters.apply(this, arguments);
      }

      return setRtpEncodingParameters;
    }() // eslint-disable-next-line @typescript-eslint/no-unused-vars

  }, {
    key: "getSenderStats",
    value: function () {
      var _getSenderStats = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(localId) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                throw new errors_1.UnsupportedError('not implemented');

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      function getSenderStats(_x13) {
        return _getSenderStats.apply(this, arguments);
      }

      return getSenderStats;
    }()
  }, {
    key: "sendDataChannel",
    value: function () {
      var _sendDataChannel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref3) {
        var ordered, maxPacketLifeTime, maxRetransmits, label, protocol, _a, options, dataChannel, offer, localSdpObject, offerMediaObject, answer, sctpStreamParameters;

        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                ordered = _ref3.ordered, maxPacketLifeTime = _ref3.maxPacketLifeTime, maxRetransmits = _ref3.maxRetransmits, label = _ref3.label, protocol = _ref3.protocol;
                this.assertSendDirection();
                options = {
                  negotiated: true,
                  id: this._nextSendSctpStreamId,
                  ordered: ordered,
                  maxPacketLifeTime: maxPacketLifeTime,
                  maxRetransmitTime: maxPacketLifeTime,
                  maxRetransmits: maxRetransmits,
                  protocol: protocol
                };
                logger.debug('sendDataChannel() [options:%o]', options);
                dataChannel = this._pc.createDataChannel(label, options); // Increase next id.

                this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % SCTP_NUM_STREAMS.MIS; // If this is the first DataChannel we need to create the SDP answer with
                // m=application section.

                if (this._hasDataChannelMediaSection) {
                  _context14.next = 24;
                  break;
                }

                _context14.next = 9;
                return this._pc.createOffer();

              case 9:
                offer = _context14.sent;
                localSdpObject = sdpTransform.parse(offer.sdp);
                offerMediaObject = localSdpObject.media.find(function (m) {
                  return m.type === 'application';
                });

                if (this._transportReady) {
                  _context14.next = 15;
                  break;
                }

                _context14.next = 15;
                return this.setupTransport({
                  localDtlsRole: (_a = this._forcedLocalDtlsRole) !== null && _a !== void 0 ? _a : 'client',
                  localSdpObject: localSdpObject
                });

              case 15:
                logger.debug('sendDataChannel() | calling pc.setLocalDescription() [offer:%o]', offer);
                _context14.next = 18;
                return this._pc.setLocalDescription(offer);

              case 18:
                this._remoteSdp.sendSctpAssociation({
                  offerMediaObject: offerMediaObject
                });

                answer = {
                  type: 'answer',
                  sdp: this._remoteSdp.getSdp()
                };
                logger.debug('sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]', answer);
                _context14.next = 23;
                return this._pc.setRemoteDescription(answer);

              case 23:
                this._hasDataChannelMediaSection = true;

              case 24:
                sctpStreamParameters = {
                  streamId: options.id,
                  ordered: options.ordered,
                  maxPacketLifeTime: options.maxPacketLifeTime,
                  maxRetransmits: options.maxRetransmits
                };
                return _context14.abrupt("return", {
                  dataChannel: dataChannel,
                  sctpStreamParameters: sctpStreamParameters
                });

              case 26:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function sendDataChannel(_x14) {
        return _sendDataChannel.apply(this, arguments);
      }

      return sendDataChannel;
    }()
  }, {
    key: "receive",
    value: function () {
      var _receive = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(optionsList) {
        var _this3 = this;

        var _a, results, mapStreamId, _iterator2, _step2, options, trackId, kind, rtpParameters, mid, streamId, offer, answer, localSdpObject, _iterator3, _step3, _loop, _iterator4, _step4, _loop2;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                this.assertRecvDirection();
                results = [];
                mapStreamId = new Map();
                _iterator2 = _createForOfIteratorHelper(optionsList);

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    options = _step2.value;
                    trackId = options.trackId, kind = options.kind, rtpParameters = options.rtpParameters;
                    logger.debug('receive() [trackId:%s, kind:%s]', trackId, kind);
                    mid = kind;
                    streamId = options.streamId || rtpParameters.rtcp.cname; // NOTE: In React-Native we cannot reuse the same remote MediaStream for new
                    // remote tracks. This is because react-native-webrtc does not react on new
                    // tracks generated within already existing streams, so force the streamId
                    // to be different. See:
                    // https://github.com/react-native-webrtc/react-native-webrtc/issues/401

                    logger.debug('receive() | forcing a random remote streamId to avoid well known bug in react-native-webrtc');
                    streamId += "-hack-".concat(utils.generateRandomNumber());
                    mapStreamId.set(trackId, streamId);

                    this._remoteSdp.receive({
                      mid: mid,
                      kind: kind,
                      offerRtpParameters: rtpParameters,
                      streamId: streamId,
                      trackId: trackId
                    });
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }

                offer = {
                  type: 'offer',
                  sdp: this._remoteSdp.getSdp()
                };
                logger.debug('receive() | calling pc.setRemoteDescription() [offer:%o]', offer);
                _context15.next = 9;
                return this._pc.setRemoteDescription(offer);

              case 9:
                _context15.next = 11;
                return this._pc.createAnswer();

              case 11:
                answer = _context15.sent;
                localSdpObject = sdpTransform.parse(answer.sdp);
                _iterator3 = _createForOfIteratorHelper(optionsList);

                try {
                  _loop = function _loop() {
                    var options = _step3.value;
                    var kind = options.kind,
                        rtpParameters = options.rtpParameters;
                    var mid = kind;
                    var answerMediaObject = localSdpObject.media.find(function (m) {
                      return String(m.mid) === mid;
                    }); // May need to modify codec parameters in the answer based on codec
                    // parameters in the offer.

                    sdpCommonUtils.applyCodecParameters({
                      offerRtpParameters: rtpParameters,
                      answerMediaObject: answerMediaObject
                    });
                  };

                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    _loop();
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }

                answer = {
                  type: 'answer',
                  sdp: sdpTransform.write(localSdpObject)
                };

                if (this._transportReady) {
                  _context15.next = 19;
                  break;
                }

                _context15.next = 19;
                return this.setupTransport({
                  localDtlsRole: (_a = this._forcedLocalDtlsRole) !== null && _a !== void 0 ? _a : 'client',
                  localSdpObject: localSdpObject
                });

              case 19:
                logger.debug('receive() | calling pc.setLocalDescription() [answer:%o]', answer);
                _context15.next = 22;
                return this._pc.setLocalDescription(answer);

              case 22:
                _iterator4 = _createForOfIteratorHelper(optionsList);

                try {
                  _loop2 = function _loop2() {
                    var options = _step4.value;
                    var kind = options.kind,
                        trackId = options.trackId,
                        rtpParameters = options.rtpParameters;
                    var localId = trackId;
                    var mid = kind;
                    var streamId = mapStreamId.get(trackId);

                    var stream = _this3._pc.getRemoteStreams().find(function (s) {
                      return s.id === streamId;
                    });

                    var track = stream.getTrackById(localId);

                    if (!track) {
                      throw new Error('remote track not found');
                    } // Insert into the map.


                    _this3._mapRecvLocalIdInfo.set(localId, {
                      mid: mid,
                      rtpParameters: rtpParameters
                    });

                    results.push({
                      localId: localId,
                      track: track
                    });
                  };

                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    _loop2();
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }

                return _context15.abrupt("return", results);

              case 25:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function receive(_x15) {
        return _receive.apply(this, arguments);
      }

      return receive;
    }()
  }, {
    key: "stopReceiving",
    value: function () {
      var _stopReceiving = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(localIds) {
        var _iterator5, _step5, localId, _ref4, mid, rtpParameters, offer, answer;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                this.assertRecvDirection();
                _iterator5 = _createForOfIteratorHelper(localIds);

                try {
                  for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                    localId = _step5.value;
                    logger.debug('stopReceiving() [localId:%s]', localId);
                    _ref4 = this._mapRecvLocalIdInfo.get(localId) || {}, mid = _ref4.mid, rtpParameters = _ref4.rtpParameters; // Remove from the map.

                    this._mapRecvLocalIdInfo.delete(localId);

                    this._remoteSdp.planBStopReceiving({
                      mid: mid,
                      offerRtpParameters: rtpParameters
                    });
                  }
                } catch (err) {
                  _iterator5.e(err);
                } finally {
                  _iterator5.f();
                }

                offer = {
                  type: 'offer',
                  sdp: this._remoteSdp.getSdp()
                };
                logger.debug('stopReceiving() | calling pc.setRemoteDescription() [offer:%o]', offer);
                _context16.next = 7;
                return this._pc.setRemoteDescription(offer);

              case 7:
                _context16.next = 9;
                return this._pc.createAnswer();

              case 9:
                answer = _context16.sent;
                logger.debug('stopReceiving() | calling pc.setLocalDescription() [answer:%o]', answer);
                _context16.next = 13;
                return this._pc.setLocalDescription(answer);

              case 13:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function stopReceiving(_x16) {
        return _stopReceiving.apply(this, arguments);
      }

      return stopReceiving;
    }()
  }, {
    key: "pauseReceiving",
    value: function () {
      var _pauseReceiving = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17( // eslint-disable-next-line @typescript-eslint/no-unused-vars
      localIds) {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }));

      function pauseReceiving(_x17) {
        return _pauseReceiving.apply(this, arguments);
      }

      return pauseReceiving;
    }()
  }, {
    key: "resumeReceiving",
    value: function () {
      var _resumeReceiving = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18( // eslint-disable-next-line @typescript-eslint/no-unused-vars
      localIds) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));

      function resumeReceiving(_x18) {
        return _resumeReceiving.apply(this, arguments);
      }

      return resumeReceiving;
    }() // eslint-disable-next-line @typescript-eslint/no-unused-vars

  }, {
    key: "getReceiverStats",
    value: function () {
      var _getReceiverStats = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(localId) {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                throw new errors_1.UnsupportedError('not implemented');

              case 1:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      }));

      function getReceiverStats(_x19) {
        return _getReceiverStats.apply(this, arguments);
      }

      return getReceiverStats;
    }()
  }, {
    key: "receiveDataChannel",
    value: function () {
      var _receiveDataChannel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(_ref5) {
        var sctpStreamParameters, label, protocol, _a, streamId, ordered, maxPacketLifeTime, maxRetransmits, options, dataChannel, offer, answer, _localSdpObject;

        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                sctpStreamParameters = _ref5.sctpStreamParameters, label = _ref5.label, protocol = _ref5.protocol;
                this.assertRecvDirection();
                streamId = sctpStreamParameters.streamId, ordered = sctpStreamParameters.ordered, maxPacketLifeTime = sctpStreamParameters.maxPacketLifeTime, maxRetransmits = sctpStreamParameters.maxRetransmits;
                options = {
                  negotiated: true,
                  id: streamId,
                  ordered: ordered,
                  maxPacketLifeTime: maxPacketLifeTime,
                  maxRetransmitTime: maxPacketLifeTime,
                  maxRetransmits: maxRetransmits,
                  protocol: protocol
                };
                logger.debug('receiveDataChannel() [options:%o]', options);
                dataChannel = this._pc.createDataChannel(label, options); // If this is the first DataChannel we need to create the SDP offer with
                // m=application section.

                if (this._hasDataChannelMediaSection) {
                  _context20.next = 23;
                  break;
                }

                this._remoteSdp.receiveSctpAssociation({
                  oldDataChannelSpec: true
                });

                offer = {
                  type: 'offer',
                  sdp: this._remoteSdp.getSdp()
                };
                logger.debug('receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]', offer);
                _context20.next = 12;
                return this._pc.setRemoteDescription(offer);

              case 12:
                _context20.next = 14;
                return this._pc.createAnswer();

              case 14:
                answer = _context20.sent;

                if (this._transportReady) {
                  _context20.next = 19;
                  break;
                }

                _localSdpObject = sdpTransform.parse(answer.sdp);
                _context20.next = 19;
                return this.setupTransport({
                  localDtlsRole: (_a = this._forcedLocalDtlsRole) !== null && _a !== void 0 ? _a : 'client',
                  localSdpObject: _localSdpObject
                });

              case 19:
                logger.debug('receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]', answer);
                _context20.next = 22;
                return this._pc.setLocalDescription(answer);

              case 22:
                this._hasDataChannelMediaSection = true;

              case 23:
                return _context20.abrupt("return", {
                  dataChannel: dataChannel
                });

              case 24:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function receiveDataChannel(_x20) {
        return _receiveDataChannel.apply(this, arguments);
      }

      return receiveDataChannel;
    }()
  }, {
    key: "setupTransport",
    value: function () {
      var _setupTransport = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(_ref6) {
        var _this4 = this;

        var localDtlsRole, localSdpObject, dtlsParameters;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                localDtlsRole = _ref6.localDtlsRole, localSdpObject = _ref6.localSdpObject;

                if (!localSdpObject) {
                  localSdpObject = sdpTransform.parse(this._pc.localDescription.sdp);
                } // Get our local DTLS parameters.


                dtlsParameters = sdpCommonUtils.extractDtlsParameters({
                  sdpObject: localSdpObject
                }); // Set our DTLS role.

                dtlsParameters.role = localDtlsRole; // Update the remote DTLS role in the SDP.

                this._remoteSdp.updateDtlsRole(localDtlsRole === 'client' ? 'server' : 'client'); // Need to tell the remote transport about our parameters.


                _context21.next = 7;
                return new Promise(function (resolve, reject) {
                  _this4.safeEmit('@connect', {
                    dtlsParameters: dtlsParameters
                  }, resolve, reject);
                });

              case 7:
                this._transportReady = true;

              case 8:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function setupTransport(_x21) {
        return _setupTransport.apply(this, arguments);
      }

      return setupTransport;
    }()
  }, {
    key: "assertSendDirection",
    value: function assertSendDirection() {
      if (this._direction !== 'send') {
        throw new Error('method can just be called for handlers with "send" direction');
      }
    }
  }, {
    key: "assertRecvDirection",
    value: function assertRecvDirection() {
      if (this._direction !== 'recv') {
        throw new Error('method can just be called for handlers with "recv" direction');
      }
    }
  }, {
    key: "name",
    get: function get() {
      return 'ReactNative';
    }
  }]);

  return ReactNative;
}(HandlerInterface_1.HandlerInterface);

exports.ReactNative = ReactNative;